var React = require('react');

function HandLizard (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M561.17 312.52A96 96 0 0 1 576 363.78V480H384v-61.46a24 24 0 0 0-11.15-20.27L261.1 327.46a48 48 0 0 0-25.69-7.46H88a24 24 0 0 1-24-24v-8a64 64 0 0 1 64-64h123.65a32 32 0 0 0 29.54-19.69l21.41-51.39A18 18 0 0 0 286 128H56A56 56 0 0 1 0 72V56a24 24 0 0 1 24-24h333.54a48 48 0 0 1 40.59 22.37z","className":"fa-secondary","key":1})]);
}

HandLizard.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = HandLizard;

HandLizard.default = HandLizard;
